<template>
    <div class="warning-wrap">
        <div class="warning-modal" @click="close"></div>
        <div class="warning-popup">
            <div class="warning-title" v-if="title" :class="`-${type}`">
                {{ $t(title) }}
            </div>
            <div class="warning-message" v-if="message">{{ message }}</div>
            <div class="warning-actions" v-if="response">
                <ActionButton
                    :label="accept"
                    @click="$emit('accept')"
                ></ActionButton>
                <ActionButton
                    color="red"
                    :label="decline"
                    @click="$emit('decline')"
                ></ActionButton>
            </div>
            <div class="warning-actions" v-if="!response">
                <ActionButton
                    color="blue"
                    :label="'Ok'"
                    @click="$emit('accept')"
                ></ActionButton>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'WarningPopup',
    props: {
        title: {
            type: String,
            default: 'LABEL_WARNING'
        },
        message: String,
        question: String,
        type: {
            type: String,
            default: 'warning'
        },
        response: {
            type: Boolean,
            default: true
        },
        acceptButton: String,
        declineButton: String
    },
    computed: {
        accept() {
            return this.acceptButton
                ? this.acceptButton
                : this.$t('SWITCHER_YES')
        },
        decline() {
            return this.declineButton
                ? this.declineButton
                : this.$t('SWITCHER_NO')
        }
    },
    methods: {
        close() {
            this.$emit('close')
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.warning-wrap {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: $toast;
    display: flex;
    justify-content: center;
    align-items: center;
}
.warning-modal {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: $modal-background;
    z-index: $toast;
}
.warning-popup {
    background: #fff;
    border-radius: 0.5rem;
    z-index: $toast;
    padding: 1rem 2rem;
    box-shadow: $modal-shadow;
    margin-top: 3rem;
    color: $input;
    max-width: 20%;
    min-width: 15%;

    @media (max-width: 1300px) {
        max-width: 80%;
    }
}
.warning-title {
    color: $accent-blue;
    font-family: $input-family;
    font-size: 1.8rem;
    text-transform: uppercase;

    &.-warning {
        color: $accent-yellow;
    }
    &.-alert {
        color: $accent-red;
    }
    &.-info {
        color: $accent-blue;
    }
}
.warning-message {
    margin-top: 0.5rem;
    font-size: 1.2rem;
}
.warning-question {
    margin-top: 0.5rem;
    font-size: 1.2rem;
    font-family: $input-family;
}
.warning-actions {
    text-align: center;
    margin-top: 1rem;
}
</style>
